import axios from "axios";
import {
  USER_EXISTS_4D,
  PRACT_LOGGED_OUT,
  PRACT_LOGGED_IN,
  USER_EXISTS_MYSQL,
  GET_PATIENTS,
  GET_LAST_TEN_RESULTS,
  CLEAR_LAST_RESULST,
  ALL_PATIENT_ORDERS,
  PATIENT_ORDER_RESULTS,
  PATIENT_ORDER_RESULTS_ONE,//api
  PATIENT_HISTORIC,
  ADD_TO_LIST,
  CLEAR_ALL_PATIENT_ORDERS,
  CLEAR_PATIENT_ORDER_RESULTS,
  //CLEAR_PATIENT_ORDER_RESULTS_ONE,//api
  CLEAR_PATIENT_HISTORIC,
  REMOVE_ALL,
  PRACTITIONER_INFO,
  ENTITY_INFO,
  SELECTED_PATIENT,
  CLEAR_SELECTED_PATIENT,
  ALL_PRACTITIONERS,
  ALL_ENTITIES,
  CLEAR_SELECTED_PRACTITIONER,
  CLEAR_PRACTITIONER_INFO,
  CLEAR_ENTITY_INFO,
  CLEAR_SELECTED_ENTITY,
  ALL_PASSWORD_CONFIGURATIONS,
} from "../types";
import api from "../api";

export const userLoggedIn = practitioner => ({
  type: PRACT_LOGGED_IN,
  practitioner
});
export const userLoggedOut = () => ({
  type: PRACT_LOGGED_OUT
});

export const login = credentials => dispatch =>
  api.user.login(credentials).then(practitioner => {
    localStorage.practitioner_token = practitioner.token;
    axios.defaults.headers.common["Authorization"] = practitioner.token;
    dispatch(userLoggedIn(practitioner));
    return practitioner;
  });

export const logout = () => dispatch => {
  localStorage.removeItem("practitioner_token");
  dispatch(get_Patients(patients));
  dispatch(clearAllPatientOrders());
  dispatch(clearGraphsList());
  dispatch(clearPatientOrderResults());
  //dispatch(clearPatientOrderResultsOne());
  dispatch(clearPatientHistoric());
  dispatch(clearLastResults());
  dispatch(clearSelectedPractitioner());
  dispatch(clearSelectedEntity());
  dispatch(clearSelectedPatient());
  dispatch(userLoggedOut());

  window.location.href = "/login";
};

export const resetPassword = data => api.user.resetPassword(data);

export const resetPasswordRequest = ({ username }) =>
  api.user.resetPasswordRequest(username);

export const validateToken = token => api.user.validateToken(token);

export const validatePractitioner = data => api.user.validatePractitioner(data);

export const userIn4D = user4D => ({
  type: USER_EXISTS_4D,
  user4D
});

export const userInMySQL = user => ({
  type: USER_EXISTS_MYSQL,
  user
});

export const check = id => dispatch =>
  api.user.check(id).then(user => dispatch(userInMySQL(user)));

// Practitioner actions

export const practitionerInfo = practitionerInfo => ({
  type: PRACTITIONER_INFO,
  practitionerInfo
});

export const selectedPractitioner = data => ({
  type: PRACTITIONER_INFO,
  practitionerInfo: { resp: { ...data } }
});

export const clearSelectedPractitioner = () => ({
  type: CLEAR_SELECTED_PRACTITIONER,
  data: {}
});

export const clearPractitionerInfo = () => ({
  type: CLEAR_PRACTITIONER_INFO,
  practitionerInfo: {}
});

export const deletePractitioner = id => dispatch =>
  api.user.delete(id).then(practitioner => {
    dispatch(getAllPractitioners({ role: 1 }));
    return null;
  });

export const allPractitionersList = allPractitioners => ({
  type: ALL_PRACTITIONERS,
  allPractitioners
});

export const getAllPractitioners = data => dispatch => {
  api.user.getPractitioners(data).then(resp => {
    dispatch(allPractitionersList(resp.data.resp));
  });
};

/** SPRINT # 45 - SCS */
export const allPasswordConfigurationsList = allPasswordConfigurations => ({
  type: ALL_PASSWORD_CONFIGURATIONS,
  allPasswordConfigurations
});

export const getAllPasswordConfigurations = () => dispatch => {
  api.user.getAllPasswordConfigurations().then(resp => {
    dispatch(allPasswordConfigurationsList(resp.data.resp));
  });
}
/** SPRINT # 45 - SCS */

// Entites actions

export const entityInfo = entityInfo => ({
  type: ENTITY_INFO,
  entityInfo
});

export const selectedEntity = data => ({
  type: ENTITY_INFO,
  entityInfo: { resp: { ...data } }
});

export const clearSelectedEntity = () => ({
  type: CLEAR_SELECTED_ENTITY,
  data: {}
});

export const clearEntityInfo = () => ({
  type: CLEAR_ENTITY_INFO,
  entityInfo: {}
});

export const deleteEntity = id => dispatch => {
  api.entities.delete(id).then(() => dispatch(getAllEntities({ role: 1 })));
};

export const allEntitiesList = allEntities => ({
  type: ALL_ENTITIES,
  allEntities
});

export const getAllEntities = data => dispatch => {
  api.user.getEntities(data).then(resp => {
    dispatch(allEntitiesList(resp.data.resp));
  });
};

// Patients actions
export const get_Patients = patients => ({
  type: GET_PATIENTS,
  patients: { ...patients }
});

//Motato Luis Se agrega condicional para validar el tipo de usuario para saber que datos cargar 
export const patients = (user) => dispatch => {
  //if(user){
    //api.patients.getPatientsSU().then(patients => {
      //dispatch(get_Patients(patients));
      //// dispatch(clearAllPatientOrders());
      //dispatch(clearGraphsList());
      //dispatch(clearPatientOrderResults());
      ////dispatch(clearPatientOrderResultsOne());
      //// dispatch(clearPatientHistoric());
    //});
  //}else{
    api.patients.getPatients().then(patients => {
      dispatch(get_Patients(patients));
      // dispatch(clearAllPatientOrders());
      dispatch(clearGraphsList());
      dispatch(clearPatientOrderResults());
      //dispatch(clearPatientOrderResultsOne());
      // dispatch(clearPatientHistoric());
    });
  //}
};

export const getLastTenResults = results => ({
  type: GET_LAST_TEN_RESULTS,
  results: { ...results }
});
// Motato Luis Se agrega condicional para validar el tipo de usuario para saber que datos cargar 
export const lastTenResults = (id,user) => dispatch => {
  if(user){
    api.patients.lastTenResults(id).then(results => {
      dispatch(getLastTenResults(results));
      // dispatch(clearAllPatientOrders());
      dispatch(clearGraphsList());
      dispatch(clearPatientOrderResults());
      //dispatch(clearPatientOrderResultsOne());
      // dispatch(clearPatientHistoric());
    });
  }else{
    api.patients.lastTenResults(id).then(results => {
      dispatch(getLastTenResults(results));
      // dispatch(clearAllPatientOrders());
      dispatch(clearGraphsList());
      dispatch(clearPatientOrderResults());
      //dispatch(clearPatientOrderResultsOne());
      // dispatch(clearPatientHistoric());
    });
  }
};

export const allPatientOrdersAction = data => ({
  type: ALL_PATIENT_ORDERS,
  orders: { ...data }
});

export const patientOrderResultsAction = data => ({
  type: PATIENT_ORDER_RESULTS,
  orderResults: { ...data }
});

export const patientOrderResultsActionOne = data => ({ //api
  type: PATIENT_ORDER_RESULTS_ONE,
  orderResults: { ...data }
});

export const patientHistoricAction = data => ({
  type: PATIENT_HISTORIC,
  historic: { ...data }
});

export const addToList = graph => {
  return {
    type: ADD_TO_LIST,
    graph
  };
};

export const clearAllPatientOrders = () => {
  return {
    type: CLEAR_ALL_PATIENT_ORDERS,
    orders: {}
  };
};
export const clearPatientOrderResults = () => {
  return {
    type: CLEAR_PATIENT_ORDER_RESULTS,
    orderResults: {}
  };
};
export const clearPatientOrderResultsOne = () => {
  return {
    type: CLEAR_PATIENT_ORDER_RESULTS,
    orderResults: {}
  };
};
export const clearPatientHistoric = () => {
  return {
    type: CLEAR_PATIENT_HISTORIC,
    historic: {}
  };
};
export const clearGraphsList = () => {
  return {
    type: REMOVE_ALL,
    graph: []
  };
};

export const clearLastResults = () => {
  return {
    type: CLEAR_LAST_RESULST,
    results: {}
  };
};

export const selectedPatient = data => {
  return {
    type: SELECTED_PATIENT,
    selected_patient: data
  };
};

export const clearSelectedPatient = () => {
  return {
    type: CLEAR_SELECTED_PATIENT,
    selected_patient: {}
  };
};
export const allPatientOrders = data => dispatch =>
  api.patients
    .allPatientOrders(data)
    .then(orders => dispatch(allPatientOrdersAction(orders)));

export const patientOrderResults = data => dispatch =>
  api.patients
    .patientOrderResults(data)
    .then(orderResults => dispatch(patientOrderResultsAction(orderResults)));

export const patientOrderResultsOne = data => dispatch =>
  api.patients
    .patientOrderResultsOne(data)
    .then(orderResults => dispatch(patientOrderResultsActionOne(orderResults)));

export const patientHistoric = data => dispatch => {
  api.patients.patientHistoric(data).then(historic => {
    dispatch(patientHistoricAction(historic));
    dispatch(addToList(historic));
  });
};
